import angular from 'angular';

import { leadApi } from '../services/api';

(function () {
  'use strict';

  angular
    .module('mobile.lead.add')
    .controller('MobileLeadAddCtrl', MobileLeadAddCtrl);

  MobileLeadAddCtrl.$inject = ['$state'];

  function MobileLeadAddCtrl($state) {
    const vm = this;

    vm.phoneOrEmail = '';
    vm.clipboard = '';
    vm.loadLeads = false;

    vm.$state = $state;

    vm.onPaste = function (e) {
      let clipboard = e.originalEvent.clipboardData.getData('text/plain');
      clipboard = clipboard.replace('+', '');
      vm.clipboard = clipboard;

      queryLeads();
    };

    async function queryLeads(params) {
      params = params || {};

      vm.loadLeads = true;

      try {
        const response = await leadApi.getAll({
          limit: params.limit || 50,
          offset: params.offset || 0,
          query: vm.clipboard,
          fields: [],
          order_by: 'updated_at',
          order: 'desc',
        });

        if (params.success) {
          params.success(response);
        } else {
          vm.leads = response.rows;
          vm.total = response.total;

          // if no results open form
          if (!vm.total) {
            $state.go('newlead.new', {
              phoneOrEmail: vm.clipboard,
              mobile: true,
            });
          }
        }
      } catch (error) {
        if (params.error) {
          params.error(error);
        } else {
          vm.leads = error;
        }
      }

      vm.loadLeads = false;
    }
  }
})();
